import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';


//Angular Material Components
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';

/****** other libaries *****/
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NgwWowModule } from 'ngx-wow';
/****** wwf custom modules *****/

import { AppHeaderComponent } from './components/app-header/app-header.component';
import { WidgetsComponent } from './components/widgets/widgets.component';

import { MagicDirective } from './directives/magic.directive';

import { HomeComponent } from './pages/home/home.component';
import { CalendarioComponent } from './pages/calendario/calendario.component';
import { CentrosComponent } from './pages/centros/centros.component';
import { EventoComponent } from './pages/evento/evento.component';
import { AreaComponent } from './pages/area/area.component';
import { ProyectoComponent } from './pages/proyecto/proyecto.component';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { ArticuloComponent } from './pages/articulo/articulo.component';
import { AppCardComponent } from './components/app-card/app-card.component';
import { BosniArticuloComponent } from './pages/bosni-articulo/bosni-articulo.component';
import { RecursoEducativoComponent } from './pages/recurso-educativo/recurso-educativo.component';
import { RecursoFormularioComponent } from './pages/recurso-formulario/recurso-formulario.component';
import { ContactoComponent } from './pages/contacto/contacto.component';
import { AppMessageComponent } from './components/app-message/app-message.component';
import { AppSearchComponent } from './components/app-search/app-search.component';
import { GameLaunchComponent } from './pages/game-launch/game-launch.component';
import { GameMainComponent } from './pages/game-main/game-main.component';
import { GameTriviaComponent } from './pages/game-trivia/game-trivia.component';
import { GameGlossaryComponent } from './pages/game-glossary/game-glossary.component';
import { GameAboutComponent } from './pages/game-about/game-about.component';
import { GameResourcesComponent } from './pages/game-resources/game-resources.component';
import { GameTutorialComponent } from './components/game-tutorial/game-tutorial.component';
import { WidgetsV2Component } from './components/widgets-v2/widgets-v2.component';
import { TriviaComponent } from './pages/trivia/trivia.component';
import { LoginComponent } from './components/login/login.component';
import { GameCreateComponent } from './pages/game-create/game-create.component';
import { CookiesModalComponent } from './components/cookies-modal/cookies-modal.component';
import { ShareComponent } from './components/share/share.component';
import { TermsComponent } from './pages/terms/terms.component';
import { TermsPrivacyComponent } from './pages/terms-privacy/terms-privacy.component';
import { TermsCookiesComponent } from './pages/terms-cookies/terms-cookies.component';

//import { AngularFontAwesomeModule } from 'angular-font-awesome';
//import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CalendarioComponent,
    AppHeaderComponent,
    WidgetsComponent,
    CentrosComponent,
    MagicDirective,
    EventoComponent,
    AreaComponent,
    ProyectoComponent,
    AppFooterComponent,
    ArticuloComponent,
    AppCardComponent,
    BosniArticuloComponent,
    RecursoEducativoComponent,
    RecursoFormularioComponent,
    ContactoComponent,
    AppMessageComponent,
    AppSearchComponent,
    GameLaunchComponent,
    GameMainComponent,
    GameTriviaComponent,
    GameGlossaryComponent,
    GameAboutComponent,
    GameResourcesComponent,
    GameTutorialComponent,
    WidgetsV2Component,
    TriviaComponent,
    LoginComponent,
    GameCreateComponent,
    CookiesModalComponent,
    ShareComponent,
    TermsComponent,
    TermsPrivacyComponent,
    TermsCookiesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    //AngularFontAwesomeModule,

    /***** ANGULAR MATERIAL ****/
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,

    /****** other libaries *****/
    InfiniteScrollModule,
    MatCarouselModule.forRoot(),
    NgbModule,
    NgwWowModule,
    //FontAwesomeModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
